<template>
  <div class="listing-form galleries margin-auto">
    <Card class="galleries-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-image"/>
        <div><p style="color:#000;font-weight:bold">Gallery</p></div>
      </div>
      <div>
        <Form label-position="top">
          <FormItem label="Awards images, team photos, ..." prop="gallery">
            <div class="d-flex-center">
              <UploadFile class="file-upload" @upload="(file, name) => {value.gallery.push({file:file,file_name:name}) }" :multiple="true">
                <div slot="content">
                  <div class="drag-photo clickable" style="padding: 40px 60px; border: 1px dashed #ccc;">
                    <Icon type="md-cloud-upload" size="20" color="#ccc"/>
                  </div>
                </div>
              </UploadFile>
              <div v-if="value.gallery.length" class="d-flex-center">
                <p v-for="(file, idx) in value.gallery" :key="idx" class="pos-relative" style="margin-left:10px;">
                  <Icon type="md-trash" color="#ed4014" class="clickable" @click="value.gallery.splice(idx, 1)" style="position:absolute;z-index:9;color:#ffffff;background:red;border-radius:50%;padding:5px;right:5px;bottom:5px;"/>
                  <Avatar shape="square" :src="file.file" size="110" />
                </p>
              </div>
            </div>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import UploadFile from '@/components/ui/UploadFile'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    UploadFile
  },

  data () {
    return {
      formData: {
        name: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.galleries {
  max-width:700px;
  .galleries-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.galleries {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
